import React, { Component } from 'react';
import { Container, Row, Col, Card } from 'reactstrap';

export class AboutSection extends Component {
  static displayName = AboutSection.name;

  render() {
    return (
      <section id="about" className="section">
        <Container>
          <h2 className="section-title">¿Quiénes Somos?</h2>
          <Row>
            <Col lg="8" className="mx-auto">
              <Card className="text-center p-4">
                <div className="card-body">
                  <h4 className="card-title mb-4" style={{ color: 'var(--dark-blue)' }}>
                    Iglesia Cristiana Centro Bíblico Rodadero
                  </h4>
                  <p className="lead mb-4">
                    Somos una comunidad de fe comprometida con el crecimiento espiritual 
                    y el servicio a Dios y a la comunidad.
                  </p>
                  <p className="mb-4">
                    Nuestra misión es compartir el amor de Jesucristo y construir una 
                    comunidad fuerte basada en los valores cristianos. Creemos en el 
                    poder transformador del evangelio y en la importancia de vivir una 
                    fe auténtica y comprometida.
                  </p>
                  <div className="row text-center mt-4">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <i className="fas fa-heart fa-3x" style={{ color: 'var(--primary-blue)' }}></i>
                      </div>
                      <h5>Amor</h5>
                      <p>Amamos a Dios y a nuestro prójimo</p>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <i className="fas fa-book fa-3x" style={{ color: 'var(--secondary-gold)' }}></i>
                      </div>
                      <h5>Fe</h5>
                      <p>Creemos en el poder de la Palabra de Dios</p>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <i className="fas fa-hands-helping fa-3x" style={{ color: 'var(--accent-blue)' }}></i>
                      </div>
                      <h5>Servicio</h5>
                      <p>Servimos a nuestra comunidad con dedicación</p>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
